import React from 'react'
import EnergyFields from './EnergyFields'
import { FormFields } from '~/components/FormFields'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import InfoPopup from '~/components/InfoPopup'
interface Props {
  energyConsumptions: any[]
}

const GreenhouseGas: React.FC<Props> = ({ energyConsumptions }) => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  return <>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <EnergyFields
        options={energyConsumptions}
      />
      <FormFields.Input
        control={control}
        typeInput='controled'
        allowDecimals={true}
        decimalScale={2}
        rules={{
          min: 0,
          max: 50,
          required: true
        }}
        suffix={' Liter/pro Kuh und Jahr'}
        noErrorMessage
        label={<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          <label>{t('Diesel consumption (l/Kuh u. Jahr)')}</label>
          <InfoPopup
            content={t('The only thing that counts here is the direct consumption for feeding (mixing the cow feed ration). \n\
             Foreign economic activities such as chopping and fertilizing, as well as the ration mix for young cattle, are not included.')}
            styleIcon={{ fontSize: '1.2em' }}
            position={'top center'}
          />
        </div>}
        withoutAsterisk
        name={'dieselConsumption'}
        placeholder={t('Diesel consumption (l/Kuh u. Jahr)')}
      />
    </div>
  </>
}
export default GreenhouseGas